// Quiz Enhanced - Advanced functionality that loads after core
(function() {
  'use strict';
  
  // Wait for core to be ready
  function waitForCore() {
    return new Promise(function(resolve) {
      if (window.quizState && window.quizState.isInitialized) {
        resolve();
      } else {
        var checkInterval = setInterval(function() {
          if (window.quizState && window.quizState.isInitialized) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 50);
      }
    });
  }

  // Load conditional logic data
  function loadConditionalLogicData() {
    if (window.conditionalLogicData && Array.isArray(window.conditionalLogicData)) {
      window.quizState.conditionalLogicData = window.conditionalLogicData;
    }
  }

  // Load product recommendations data
  function loadProductRecommendationsData() {
    if (window.productRecommendationsData && Array.isArray(window.productRecommendationsData)) {
      window.quizState.productRecommendationsData = window.productRecommendationsData;
    }
  }

  // Enhanced step display with conditional logic
  function shouldDisplayStep(stepNumber) {
    var display = true;

    var conditions = window.quizState.conditionalLogicData.filter(function(logic) {
      return logic.step == stepNumber;
    });

    if (conditions.length === 0) {
      return true; // No conditions, always display
    }

    conditions.forEach(function(logic) {
      var prevStepAnswer = window.quizState.formData['step_' + logic.question_step];

      if (prevStepAnswer !== undefined && logic.operator) {
        if (logic.operator === 'equals') {
          if (Array.isArray(prevStepAnswer)) {
            if (!prevStepAnswer.some(function(answer) { 
              return answer.trim().toLowerCase() === logic.value.trim().toLowerCase(); 
            })) {
              display = false;
            }
          } else {
            if (prevStepAnswer.trim().toLowerCase() !== logic.value.trim().toLowerCase()) {
              display = false;
            }
          }
        }
        
        if (logic.operator === 'does not equal') {
          if (Array.isArray(prevStepAnswer)) {
            if (prevStepAnswer.some(function(answer) { 
              return answer.trim().toLowerCase() === logic.value.trim().toLowerCase(); 
            })) {
              display = false;
            }
          } else {
            if (prevStepAnswer.trim().toLowerCase() === logic.value.trim().toLowerCase()) {
              display = false;
            }
          }
        }
      } else {
        display = false;
      }
    });

    return display;
  }

  // Enhanced next step navigation
  function goToNextStepEnhanced() {
    var nextIndex = window.quizState.currentStepIndex + 1;
    while (nextIndex < window.quizState.stepList.length) {
      var nextStep = window.quizState.stepList[nextIndex];

      if (shouldDisplayStep(nextStep)) {
        // Hide the current step
        window.quizCore.hideStepByIndex(window.quizState.currentStepIndex);

        // Show the next step
        window.quizCore.showStepByIndex(nextIndex);

        // Send formData to the iframe when reaching the user_info step
        if (nextStep === 'user_info') {
          sendQuizDataToIframe(window.quizState.formData);
        }

        // Trigger product recommendations if reaching the recommendations step
        if (nextStep === 'recommendations') {
          displayRecommendations();
        }

        return;
      }
      nextIndex++;
    }

    // Display results if there are no more steps
    displayResults();
  }

  // Enhanced previous step navigation
  function goToPreviousStepEnhanced() {
    var prevIndex = window.quizState.currentStepIndex - 1;
    while (prevIndex >= 0) {
      var prevStep = window.quizState.stepList[prevIndex];
      if (shouldDisplayStep(prevStep)) {
        window.quizCore.hideStepByIndex(window.quizState.currentStepIndex);
        window.quizCore.showStepByIndex(prevIndex);
        return;
      }
      prevIndex--;
    }
  }

  // Product recommendations display
  function displayRecommendations() {
    var recommendationsContainer = document.getElementById('product-recommendations');
    if (!recommendationsContainer) return;
    
    recommendationsContainer.innerHTML = '';
    recommendationsContainer.parentElement.style.display = 'grid';

    // Sort recommendations by priority (ascending)
    var sortedRecommendations = window.quizState.productRecommendationsData.slice().sort(function(a, b) {
      return (a.priority || 0) - (b.priority || 0);
    });

    var displayedProducts = new Set();

    sortedRecommendations.forEach(function(recommendation) {
      var shouldDisplay = false;

      if (recommendation.conditions && recommendation.conditions.length > 0) {
        shouldDisplay = recommendation.conditions.every(function(condition) {
          var relevantAnswer = window.quizState.formData['step_' + condition.question_step];

          if (relevantAnswer !== undefined) {
            var conditionValue = condition.value.trim().toLowerCase();

            if (condition.operator === 'equals') {
              if (Array.isArray(relevantAnswer)) {
                return relevantAnswer.some(function(answer) { 
                  return answer.trim().toLowerCase() === conditionValue; 
                });
              } else {
                return relevantAnswer.trim().toLowerCase() === conditionValue;
              }
            } else if (condition.operator === 'does not equal') {
              if (Array.isArray(relevantAnswer)) {
                return !relevantAnswer.some(function(answer) { 
                  return answer.trim().toLowerCase() === conditionValue; 
                });
              } else {
                return relevantAnswer.trim().toLowerCase() !== conditionValue;
              }
            }
          }
          return false;
        });
      } else {
        shouldDisplay = true;
      }

      if (shouldDisplay) {
        var targets = recommendation.targets;

        if (Array.isArray(targets) && targets.length > 0) {
          targets.forEach(function(target) {
            if (target && target.handle) {
              var productKey = target.handle;
              if (!displayedProducts.has(productKey)) {
                displayedProducts.add(productKey);
                createProductCard(target, recommendationsContainer);
              }
            }
          });
        }
      }
    });

    recommendationsContainer.scrollIntoView({ behavior: 'smooth' });
  }

  function createProductCard(target, container) {
    var recommendationElement = document.createElement('li');
    recommendationElement.classList.add('grid__item');

    var title = target.title || 'Recommended Item';
    var handle = target.handle;
    var imageSrc = target.image || '';
    var price = target.price || '';
    var compareAtPrice = target.compare_at_price || '';
    var tags = target.tags || [];
    var isBestSeller = tags.includes('Best Seller');
    var isVegan = tags.includes('Vegan');
    var isVegetarian = tags.includes('Vegetarian');
    var isNew = tags.includes('New');
    var isTrending = tags.includes('Trending');
    var isOnSale = compareAtPrice && compareAtPrice !== price;
    var description = target.description;

    recommendationElement.innerHTML = `
      <div class="quiz-rec-card">
        <div class="quiz-rec-image">
          <a href="/products/${handle}">
            <img src="${imageSrc}" alt="${title}" loading="lazy">
          </a>
        </div>
        
        <div class="quiz-rec-content">
          <h3 class="quiz-rec-title">
            <a href="/products/${handle}">${title}</a>
          </h3>
          
          <div class="quiz-rec-price">
            ${price}
          </div>
          
          ${description ? `
            <div class="quiz-rec-why">
              <h4 class="quiz-rec-why-title">Why we recommend this:</h4>
              <div class="quiz-rec-why-text">${description}</div>
            </div>
          ` : ''}
          
          <a href="/products/${handle}" class="quiz-rec-button">View Product</a>
        </div>
      </div>
    `;

    container.appendChild(recommendationElement);
  }

  // Send quiz data to iframe
  function sendQuizDataToIframe(quizData) {
    var iframe = document.querySelector('.pxFormGenerator iframe');

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: 'populateFields', quizData: quizData }, '*');
    }
  }

  // Transform questions for child-specific phrasing
  function transformQuestionsForChild() {
    var questionElements = document.querySelectorAll('.quiz-step h2, .quiz-step h3');

    var replacements = {
      "Are you": "Is your child",
      "What is your": "What is your child's",
      "Do you": "Does your child",
      "Have you": "Has your child",
      "Do you have": "Does your child have"
    };

    questionElements.forEach(function (question) {
      var text = question.textContent;

      for (var key in replacements) {
        var regex = new RegExp("\\b" + key + "\\b", "gi");
        text = text.replace(regex, replacements[key]);
      }

      question.textContent = text;
    });
  }

  // Enhanced results display
  function displayResults() {
    var results = document.createElement('div');
    results.id = 'quiz-results';
    results.innerHTML = '<h2>Thank you for completing the quiz!</h2><pre>' + JSON.stringify(window.quizState.formData, null, 2) + '</pre>';
    document.getElementById('quiz-form').appendChild(results);
  }

  // Initialize enhanced functionality
  async function initializeEnhanced() {
    await waitForCore();
    
    // Load data
    loadConditionalLogicData();
    loadProductRecommendationsData();
    
    // Override core functions with enhanced versions
    window.quizCore.goToNextStep = goToNextStepEnhanced;
    window.quizCore.goToPreviousStep = goToPreviousStepEnhanced;
    
    // Add enhanced event listeners
    var nextButtons = document.querySelectorAll('button.next-button, a.next-button');
    nextButtons.forEach(function(button) {
      // Remove existing listeners and add enhanced ones
      var newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', function(event) {
        if (newButton.tagName.toLowerCase() === 'a') {
          event.preventDefault();
        }

        var stepElement = this.closest('.quiz-step');
        var stepIdentifier = stepElement.getAttribute('data-step');
        var stepIndex = window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) >= 0 ? 
          window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) : 
          window.quizState.stepList.indexOf(stepIdentifier);

        // Save user input
        var inputs = stepElement.querySelectorAll('input');
        inputs.forEach(function(input) {
          if (input.type === 'radio' && input.checked) {
            window.quizState.formData['step_' + stepIdentifier] = input.value;
          } else if (input.type === 'checkbox' && input.checked) {
            if (!window.quizState.formData['step_' + stepIdentifier]) {
              window.quizState.formData['step_' + stepIdentifier] = [];
            }
            window.quizState.formData['step_' + stepIdentifier].push(input.value);
          } else if (input.type === 'text' || input.type === 'email') {
            window.quizState.formData[input.name] = input.value.trim();
          }
        });

        // Check if Step 01 equals "Shopping for my child"
        if (stepIdentifier === "1" && window.quizState.formData['step_1'] === "Shopping for my child") {
          transformQuestionsForChild();
        }

        // Hide current step
        window.quizCore.hideStepByIndex(stepIndex);

        // Show next step
        window.quizCore.goToNextStep();
      });
    });

    // Enhanced back button functionality
    var backButtons = document.querySelectorAll('.back-button');
    backButtons.forEach(function(button) {
      var newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', function() {
        var stepElement = this.closest('.quiz-step');
        var stepIdentifier = stepElement.getAttribute('data-step');
        var stepIndex = window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) >= 0 ? 
          window.quizState.stepList.indexOf(parseFloat(stepIdentifier)) : 
          window.quizState.stepList.indexOf(stepIdentifier);

        window.quizCore.hideStepByIndex(stepIndex);
        window.quizCore.goToPreviousStep();
      });
    });

    // Form submission listener
    window.addEventListener("message", function(event) {
      if (event.origin !== "https://formbuilder.hulkapps.com" && event.origin !== "https://herbs-of-gold.myshopify.com") {
        return;
      }

      if (event.data && event.data.type === "formSubmitted") {
        window.quizCore.goToNextStep();
      }
    });

    // Start again button
    var startAgainButton = document.querySelector('.start-again-button');
    if (startAgainButton) {
      startAgainButton.addEventListener('click', function() {
        location.reload();
      });
    }
  }

  // Start loading enhanced functionality after a short delay
  setTimeout(initializeEnhanced, 100);

})();
